// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader___2poJ3","zoomAnimation":"zoomAnimation___2RCmu"};